import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...clases: ClassValue[]): string {
  return twMerge(clsx(clases));
}

const formatoFecha = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});
const formatoFechaHora = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  day: '2-digit',
  month: 'short',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});
const formatoDiaLargo = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  weekday: 'long',
  day: 'numeric',
  month: 'long',
});

export const fecha = (valor: string | Date) => formatoFecha.format(new Date(valor));
export const fechaHora = (valor: string | Date) => formatoFechaHora.format(new Date(valor));
/** `'2026-09-28'` → `'lunes, 28 de septiembre'` */
export const diaLargo = (dia: string) => formatoDiaLargo.format(new Date(`${dia}T12:00:00-06:00`));

export function iniciales(nombre: string): string {
  return nombre
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
}
